'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unionByID = exports.initialState = exports.clearSearch = exports.FILTER_BY_CATEGORY = exports.SET_CATEGORY_SLUG = exports.SET_CATEGORY = exports.CATEGORIES_FETCH_FAILED = exports.CATEGORIES_FETCHED = exports.FETCH_CATEGORIES = exports.UPDATE_CONNECTED_STATUS = exports.WAIT = exports.FILTER_LISTINGS_BY_ALL = exports.CLEAR_SEARCH = exports.LISTINGS_SET_SEARCH = exports.LISTINGS_FETCH_FAILED = exports.LISTINGS_FETCHED = exports.LISTINGS_FETCHING = exports.LISTINGS_INVALID = undefined;
exports.setSearch = setSearch;
exports.filterListingsByAll = filterListingsByAll;
exports.wait = wait;
exports.updateConnectedStatus = updateConnectedStatus;
exports.setAndFilter = setAndFilter;
exports.fetchListings = fetchListings;
exports.filterByCategory = filterByCategory;
exports.setCategory = setCategory;
exports.fetchCategoriesIfNeeded = fetchCategoriesIfNeeded;
exports.setAndFilterByCategory = setAndFilterByCategory;
exports.setCategorySlug = setCategorySlug;
exports.shouldFetchListings = shouldFetchListings;
exports.fetchListingsIfNeeded = fetchListingsIfNeeded;
exports.filterByField = filterByField;
exports.default = listings;

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _uniqBy2 = require('lodash/uniqBy');

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

var _some2 = require('lodash/some');

var _some3 = _interopRequireDefault(_some2);

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _intersection2 = require('lodash/intersection');

var _intersection3 = _interopRequireDefault(_intersection2);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _utils = require('../utils');

var _userProfileModule = require('../userProfile/userProfileModule');

var userProfileActions = _interopRequireWildcard(_userProfileModule);

var _listingModule = require('../listing/listingModule');

var listingActions = _interopRequireWildcard(_listingModule);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Constants
var LISTINGS_INVALID = exports.LISTINGS_INVALID = '@@listings/LISTINGS_INVALID';
var LISTINGS_FETCHING = exports.LISTINGS_FETCHING = '@@listings/LISTINGS_FETCHING';
var LISTINGS_FETCHED = exports.LISTINGS_FETCHED = '@@listings/LISTINGS_FETCHED';
var LISTINGS_FETCH_FAILED = exports.LISTINGS_FETCH_FAILED = '@@listings/LISTINGS_FETCH_FAILED';
var LISTINGS_SET_SEARCH = exports.LISTINGS_SET_SEARCH = '@@listings/LISTINGS_SET_SEARCH';
var CLEAR_SEARCH = exports.CLEAR_SEARCH = '@@listings/CLEAR_SEARCH';
var FILTER_LISTINGS_BY_ALL = exports.FILTER_LISTINGS_BY_ALL = '@@listings/FILTER_LISTINGS_BY_ALL';
var WAIT = exports.WAIT = '@@listings/WAIT';
var UPDATE_CONNECTED_STATUS = exports.UPDATE_CONNECTED_STATUS = '@@listings/UPDATE_CONNECTED_STATUS';
var FETCH_CATEGORIES = exports.FETCH_CATEGORIES = '@@listings/FETCH_CATEGORIES';
var CATEGORIES_FETCHED = exports.CATEGORIES_FETCHED = '@@listings/CATEGORIES_FETCHED';
var CATEGORIES_FETCH_FAILED = exports.CATEGORIES_FETCH_FAILED = '@@listings/CATEGORIES_FETCH_FAILED';
var SET_CATEGORY = exports.SET_CATEGORY = '@@listings/SET_CATEGORY';
var SET_CATEGORY_SLUG = exports.SET_CATEGORY_SLUG = '@@listings/SET_CATEGORY_SLUG';
var FILTER_BY_CATEGORY = exports.FILTER_BY_CATEGORY = '@@listings/FILTER_BY_CATEGORY';

var APIEndpoint = void 0;
if ((0, _utils.canUseDOM)()) {
  APIEndpoint = _config2.default.appcenterAPIBase.client + '/api/listings';
} else {
  APIEndpoint = _config2.default.appcenterAPIBase.server + '/api/listings';
}

// Actions

function setSearch(value) {
  return { type: LISTINGS_SET_SEARCH, value: value };
}

function filterListingsByAll() {
  return {
    type: FILTER_LISTINGS_BY_ALL
  };
}

// this is only to introduce artificial delay, (don't test it)
function wait(time) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(dispatch({ type: WAIT }));
      }, time);
    });
  };
}

function updateConnectedStatus(listingId, status) {
  return function (dispatch, getState) {
    var _getState$listings = getState().listings,
        list = _getState$listings.list,
        filtered = _getState$listings.filtered;


    var updateList = function updateList(listToUpdate) {
      return listToUpdate.map(function (el) {
        if (el.ID === listingId) {
          return (0, _merge3.default)({}, el, {
            isConnecting: false,
            core: {
              isUserConnected: status
            }
          });
        }
        return el;
      });
    };

    if (list.length > 0 || filtered.length > 0) {
      var newList = updateList(list);
      var newFilteredList = updateList(filtered);
      dispatch({ type: UPDATE_CONNECTED_STATUS, newList: newList, newFilteredList: newFilteredList });
    }
  };
}

function setAndFilter(value) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch(setSearch(value));
      resolve(dispatch(filterListingsByAll()));
    });
  };
}

function fetchListings() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var fetchListingsCall = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var options, response;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  options = { method: 'GET', headers: {} };

                  if (token) options.headers.Authorization = 'Bearer ' + token;

                  _context.next = 4;
                  return fetch(endpoint, options);

                case 4:
                  response = _context.sent;
                  return _context.abrupt('return', response.json());

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function fetchListingsCall() {
          return _ref2.apply(this, arguments);
        };
      }();

      var _getState, _getState$userPrefs$l, lang, userProfile, _getState$JWT, _getState$JWT$token, token, listings, meta, parameters, extraCountries, endpoint, listingsResponse, approvedAndVisible, _getState2, _getState2$listings, categorySlug, list, search;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(userProfileActions.fetchUserProfileIfNeeded());

            case 2:
              dispatch({ type: LISTINGS_FETCHING });
              _getState = getState(), _getState$userPrefs$l = _getState.userPrefs.localeData.lang, lang = _getState$userPrefs$l === undefined ? 'en-us' : _getState$userPrefs$l, userProfile = _getState.userProfile, _getState$JWT = _getState.JWT;
              _getState$JWT = _getState$JWT === undefined ? {} : _getState$JWT;
              _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === undefined ? '' : _getState$JWT$token, listings = _getState.listings, meta = _getState.meta;
              parameters = {
                category: (0, _get3.default)(listings, 'category.slug', ''),
                lang: lang
              };

              // The Public US site should show listings for ALL countries.
              // This is an exception. Other countries should still limit the results.

              if (meta.isPublic && meta.country !== 'US' && meta.country !== 'CN') {
                parameters.country = meta.country;
              }

              // Request HK, TW, CN listings when in public china
              extraCountries = meta.isPublic && meta.country === 'CN' ? '&country=CN,TW,HK' : '';
              endpoint = '' + APIEndpoint + (0, _utils.buildQueryString)(parameters) + extraCountries;
              _context2.prev = 10;
              _context2.next = 13;
              return fetchListingsCall();

            case 13:
              listingsResponse = _context2.sent;
              approvedAndVisible = listingsResponse.items.filter(function (item) {
                // in public show only if localized content is available
                var fixedLang = lang === 'en' ? 'en-us' : lang;
                if (meta.isPublic && item.localized && item.localized.lang !== fixedLang) {
                  return false;
                }

                if (item.core.isVisible && item.core.approvalStatus === 'APPROVED') {
                  if (token && item.core.clientOptInType === 'USER') {
                    return (0, _intersection3.default)(item.core.offerings, userProfile.offeringsEnabled).length > 0;
                  }
                  return true;
                }
              });


              dispatch(listingActions.setListings(approvedAndVisible));

              dispatch({ type: LISTINGS_FETCHED, result: approvedAndVisible });
              dispatch({ type: FILTER_LISTINGS_BY_ALL });

              _getState2 = getState(), _getState2$listings = _getState2.listings, categorySlug = _getState2$listings.categorySlug, list = _getState2$listings.list, search = _getState2$listings.search;


              if (categorySlug && list.length && search === '') {
                dispatch(setCategory());
              }
              _context2.next = 25;
              break;

            case 22:
              _context2.prev = 22;
              _context2.t0 = _context2['catch'](10);

              dispatch({ type: LISTINGS_FETCH_FAILED, error: _context2.t0 });

            case 25:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[10, 22]]);
    }));

    function asyncFetchListings(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return asyncFetchListings;
  }();
}

function flattenCategories(list) {
  var flattened = {};
  list.forEach(function (category) {
    flattened[category.slug] = category;
    if (category.subcategories.length > 0) {
      category.subcategories.forEach(function (subCategory) {
        return flattened[subCategory.slug] = subCategory;
      });
    }
  });
  return flattened;
}

function filterByCategory() {
  return { type: FILTER_BY_CATEGORY };
}

function setCategory(givenCatgory) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        _getState3$listings$c = _getState3.listings.categories,
        categories = _getState3$listings$c === undefined ? [] : _getState3$listings$c;

    if (givenCatgory) {
      dispatch({ type: SET_CATEGORY, category: givenCatgory });
      dispatch(filterByCategory());
    } else if (categories.length) {
      var flatMapCategories = flattenCategories(categories);

      var theChosenOne = flatMapCategories[getState().listings.categorySlug];

      dispatch({ type: SET_CATEGORY, category: theChosenOne });
      dispatch(filterByCategory());
    }

    if (!categories.length) {
      dispatch(fetchCategoriesIfNeeded());
    }
  };
}

function fetchCategoriesIfNeeded() {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _getState4, categories, _getState4$userPrefs$, lang, path, categoriesAPIEndpoint, options, response, categoriesResponse;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState4 = getState(), categories = _getState4.listings.categories, _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang, lang = _getState4$userPrefs$ === undefined ? 'en-us' : _getState4$userPrefs$;

              if (!(!categories || categories.length === 0)) {
                _context3.next = 21;
                break;
              }

              path = 'api/listitems/categories?lang=' + lang;
              categoriesAPIEndpoint = void 0;

              if ((0, _utils.canUseDOM)()) {
                categoriesAPIEndpoint = _config2.default.appcenterAPIBase.client + '/' + path;
              } else {
                categoriesAPIEndpoint = _config2.default.appcenterAPIBase.server + '/' + path;
              }

              dispatch({ type: FETCH_CATEGORIES });

              options = {
                method: 'GET',
                headers: {}
              };
              _context3.prev = 7;
              _context3.next = 10;
              return fetch(categoriesAPIEndpoint, options);

            case 10:
              response = _context3.sent;
              _context3.next = 13;
              return response.json();

            case 13:
              categoriesResponse = _context3.sent;


              dispatch({ type: CATEGORIES_FETCHED, result: categoriesResponse });

              return _context3.abrupt('return', categoriesResponse);

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3['catch'](7);

              dispatch({ type: CATEGORIES_FETCH_FAILED, error: _context3.t0 });

            case 21:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[7, 18]]);
    }));

    function asyncFetchCategories(_x3, _x4) {
      return _ref3.apply(this, arguments);
    }

    return asyncFetchCategories;
  }();
}

function setAndFilterByCategory(value) {
  return function (dispatch) {
    dispatch(setCategory(value));
    dispatch(filterByCategory());
  };
}

function setCategorySlug(slug) {
  return {
    type: SET_CATEGORY_SLUG,
    slug: slug
  };
}

function shouldFetchListings(state, isKeywordEntered) {
  var currentListings = state.listings;

  if (currentListings.list === null || currentListings.list.length === 0 || currentListings.listingsReadyState === LISTINGS_FETCH_FAILED || currentListings.listingsReadyState === LISTINGS_INVALID || isKeywordEntered) {
    return true;
  }

  return false;
}

function fetchListingsIfNeeded() {
  return function (dispatch, getState) {
    if (shouldFetchListings(getState(), getState().listings.search.length > 0)) {
      return dispatch(fetchListings());
    }
  };
}

var clearSearch = exports.clearSearch = function clearSearch() {
  return {
    type: CLEAR_SEARCH
  };
};

// Reducer

var initialState = exports.initialState = {
  listingsReadyState: LISTINGS_INVALID,
  list: [],
  search: '',
  filtered: [],
  category: undefined,
  categories: [],
  categorySlug: undefined
};

function filterByField(_ref4, field) {
  var search = _ref4.search,
      list = _ref4.list;

  return list.filter(function (listing) {
    var localized = listing.localized;

    if (!localized || !localized[field]) {
      return false;
    }

    var lowCaseSearch = search.toLowerCase();
    if (field === 'keywords') {
      var words = localized[field];
      return (0, _some3.default)(words, function (value) {
        return value.toLowerCase().includes(lowCaseSearch) || lowCaseSearch.includes(value.toLowerCase());
      });
    }
    var lowCaseField = localized[field].toLowerCase();
    return lowCaseField.includes(lowCaseSearch) || lowCaseSearch.includes(lowCaseField);
  });
}

function filterByCategoryReducer(state) {
  return state.list.filter(function (listing) {
    return listing.core.categories.includes(state.category.code);
  });
}

var unionByID = exports.unionByID = function unionByID(sets) {
  var result = (0, _uniqBy3.default)(sets, 'ID');
  return result;
};

function listings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case LISTINGS_FETCHING:
      return (0, _objectAssign2.default)({}, state, {
        listingsReadyState: LISTINGS_FETCHING
      });
    case LISTINGS_FETCH_FAILED:
      return (0, _objectAssign2.default)({}, state, {
        listingsReadyState: LISTINGS_FETCH_FAILED,
        error: action.error
      });
    case LISTINGS_FETCHED:
      return (0, _objectAssign2.default)({}, state, {
        listingsReadyState: LISTINGS_FETCHED,
        list: action.result,
        filtered: action.result
      });
    case LISTINGS_SET_SEARCH:
      return (0, _objectAssign2.default)({}, state, {
        search: action.value,
        categorySlug: 'all',
        category: {
          code: 'ALL_APPS',
          description: 'All Apps',
          parentCategory: null,
          slug: 'all'
        }
      });
    case CLEAR_SEARCH:
      return (0, _objectAssign2.default)({}, state, {
        search: ''
      });
    case UPDATE_CONNECTED_STATUS:
      return (0, _merge3.default)({}, state, {
        list: action.newList,
        filtered: action.newFilteredList
      });
    case FILTER_LISTINGS_BY_ALL:
      {
        var flattened = [].concat(_toConsumableArray(filterByField(state, 'title')), _toConsumableArray(filterByField(state, 'publisher')), _toConsumableArray(filterByField(state, 'keywords')), _toConsumableArray(filterByField(state, 'name')));
        return (0, _objectAssign2.default)({}, state, {
          filtered: state.search === '' ? state.list : unionByID(flattened)
        });
      }
    case FILTER_BY_CATEGORY:
      return (0, _objectAssign2.default)({}, state, {
        filtered: state.category && state.category.slug !== 'all' ? filterByCategoryReducer(state) : state.list
      });
    case FETCH_CATEGORIES:
      return (0, _objectAssign2.default)({}, state, {
        categoriesReadyState: FETCH_CATEGORIES
      });
    case CATEGORIES_FETCHED:
      return (0, _objectAssign2.default)({}, state, {
        categoriesReadyState: CATEGORIES_FETCHED,
        categories: action.result
      });
    case CATEGORIES_FETCH_FAILED:
      return (0, _objectAssign2.default)({}, state, {
        categoriesReadyState: CATEGORIES_FETCH_FAILED,
        error: action.error
      });
    case SET_CATEGORY:
      return (0, _objectAssign2.default)({}, state, {
        category: action.category,
        search: ''
      });
    case SET_CATEGORY_SLUG:
      return (0, _objectAssign2.default)({}, state, {
        categorySlug: action.slug
      });
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/listings/listingsModule.js
// module id = 38
// module chunks = 0